<article class="legal">
  <header class="legal__header">
    <h1 class="legal__title">{{ doc.title }}</h1>
    <p class="legal__meta">
      Última actualización: {{ doc.lastUpdated }} · Versión {{ doc.version }}
    </p>
  </header>

  @if (doc.intro; as intro) {
    <p class="legal__intro">
      <ng-container [ngTemplateOutlet]="spansTpl" [ngTemplateOutletContext]="{ $implicit: intro }" />
    </p>
  }

  @for (section of doc.sections; track section.id) {
    <section class="legal__section">
      <h2 class="legal__section-title" [id]="section.id">{{ section.heading }}</h2>

      @for (block of section.blocks; track $index) {
        @switch (block.kind) {
          @case ('paragraph') {
            <p class="legal__paragraph">
              <ng-container
                [ngTemplateOutlet]="spansTpl"
                [ngTemplateOutletContext]="{ $implicit: block.spans }"
              />
            </p>
          }
          @case ('subheading') {
            <h3 class="legal__subheading">{{ block.text }}</h3>
          }
          @case ('note') {
            <blockquote class="legal__note">
              <p>
                <ng-container
                  [ngTemplateOutlet]="spansTpl"
                  [ngTemplateOutletContext]="{ $implicit: block.spans }"
                />
              </p>
            </blockquote>
          }
          @case ('list') {
            <ng-container
              [ngTemplateOutlet]="listTpl"
              [ngTemplateOutletContext]="{ $implicit: block.list }"
            />
          }
          @case ('contact') {
            <ul class="legal__contact">
              <li>
                <span class="legal__contact-label">Correo:</span>
                <a class="legal__link" [href]="'mailto:' + block.email">{{ block.email }}</a>
              </li>
              <li>
                <span class="legal__contact-label">Teléfono / WhatsApp:</span>
                {{ block.phone }}
              </li>
              <li>
                <span class="legal__contact-label">Horario de atención:</span>
                {{ block.hours }}
              </li>
            </ul>
          }
        }
      }
    </section>
  }
</article>

<!-- Renderiza una lista semántica (<ol>/<ul>), recursiva para sublistas anidadas. -->
<ng-template #listTpl let-list>
  @if (list.ordered) {
    <ol class="legal__list">
      @for (item of list.items; track $index) {
        <li>
          <ng-container
            [ngTemplateOutlet]="spansTpl"
            [ngTemplateOutletContext]="{ $implicit: item.spans }"
          />
          @if (item.sublist; as sublist) {
            <ng-container
              [ngTemplateOutlet]="listTpl"
              [ngTemplateOutletContext]="{ $implicit: sublist }"
            />
          }
        </li>
      }
    </ol>
  } @else {
    <ul class="legal__list">
      @for (item of list.items; track $index) {
        <li>
          <ng-container
            [ngTemplateOutlet]="spansTpl"
            [ngTemplateOutletContext]="{ $implicit: item.spans }"
          />
          @if (item.sublist; as sublist) {
            <ng-container
              [ngTemplateOutlet]="listTpl"
              [ngTemplateOutletContext]="{ $implicit: sublist }"
            />
          }
        </li>
      }
    </ul>
  }
</ng-template>

<!-- Renderiza segmentos inline: texto con énfasis (<strong>/<em>) o enlace interno. -->
<ng-template #spansTpl let-spans>
  @for (span of spans; track $index) {
    @if (span.to) {
      <a class="legal__link" [routerLink]="'/' + span.to" [fragment]="span.fragment">{{
        span.text
      }}</a>
    } @else {
      <span [innerHTML]="span.text"></span>
    }
  }
</ng-template>
